// extracted by mini-css-extract-plugin
export var Inner = "ThirdScreen-module--Inner--cmh8Z";
export var LangHY = "ThirdScreen-module--LangHY--us8Ue";
export var Text = "ThirdScreen-module--Text--6Di5Q";
export var AllContent = "ThirdScreen-module--AllContent--90Bwc";
export var SectionTitle = "ThirdScreen-module--SectionTitle--Po808";
export var WhiteBlock = "ThirdScreen-module--WhiteBlock--XzSvf";
export var Diagonal = "ThirdScreen-module--Diagonal--XFKj5";
export var Content = "ThirdScreen-module--Content--nvHWc";
export var TextContent = "ThirdScreen-module--TextContent--DSnJy";
export var Title = "ThirdScreen-module--Title--LpBAp";
export var AboutText = "ThirdScreen-module--AboutText--Lpydu";
export var Btn = "ThirdScreen-module--Btn--UQwZY";
export var arrowLeft = "ThirdScreen-module--arrowLeft--VO+Ih";
export var arrowRight = "ThirdScreen-module--arrowRight--i2pCV";